import { tabletQuery } from '@globals/themes/themeConstants'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ReactNode } from 'react'

type RecognitionModalViewLayoutProps = {
  children: ReactNode
}
const RecognitionModalViewLayout: React.FC<RecognitionModalViewLayoutProps> = ({ children }) => {
  const isTablet = useMediaQuery(tabletQuery)
  return isTablet ? (
    <Box
      sx={{
        p: 2,
      }}>
      {children}
    </Box>
  ) : (
    <Box
      sx={{
        p: 2,
        maxHeight: 800,
        width: 600,
        overflowX: 'hidden',
      }}>
      {children}
    </Box>
  )
}

export default RecognitionModalViewLayout
